import { Navigate } from 'react-router-dom';
import { mainRouteInitial } from '../../../Data/Constant';
import Cookies from 'js-cookie';

const RegisterNewVendorPR = ({ children }) => {
    const isVendorUserID = Cookies.get('VENDER_NIGHT_EYE_USER_ID');
    const isStep1 = Cookies.get("IsStep1Completed")==="true" 
    const isStep2 = Cookies.get("IsStep2Completed")==="true"
    const isStep3 = Cookies.get("IsStep3Completed")==="true"
   
    if (isStep1 && isStep2 && isStep3) {
        return <Navigate to={`/${mainRouteInitial}/registerVendorList`} replace />;
        // or to home: "/"
        // or to vendor profile: `/${mainRouteInitial}/vendor/profile`
    }
    // If already has user ID → already registered → redirect away
    if (isVendorUserID) {
        return <Navigate to={`/${mainRouteInitial}/VendorRegistrationForm`} replace />;
        // or to home: "/"
        // or to vendor profile: `/${mainRouteInitial}/vendor/profile`
    }


    // No user ID → show registration form
    return <>{children}</>;
};

export default RegisterNewVendorPR;